import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { German } from "flatpickr/dist/l10n/de.js";

export const AdminManagementDateInputField: React.FC<{
  label: string;
  value: string;
  onChange: (dateString: string) => void;
  initialData?: any;
}> = ({ label, value, onChange, initialData }) => {
  const [borderColor, setBorderColor] = useState("2px solid var(--green)");
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    value ? parseDate(value) : null
  );

  useEffect(() => {
    setBorderColor("2px solid var(--green)");
  }, [initialData]);

  function parseDate(val: string): Date | null {
    const parts = val.split(".");
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  }

  function formatDate(date: Date): string {
    return date.toLocaleDateString("de-DE");
  }

  function handleChange(dates: Date[]) {
    const picked = dates[0];
    if (!picked) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Wenn Datum in der Vergangenheit oder heute → Orange
    if (picked <= today) {
      setBorderColor("2px solid var(--orange)");
      setSelectedDate(picked);
      onChange(formatDate(picked));
    } else {
      setBorderColor("2px solid var(--red)");
      setSelectedDate(picked);
    }
  }

  return (
    <Box
      sx={{
        border: borderColor,
        borderRadius: "var(--borderRadiusLarge)",
        padding: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "var(--h3)",
          color: "var(--grey)",
          paddingBottom: "10px",
        }}
      >
        {label}
      </Typography>
      <Flatpickr
        value={selectedDate || undefined}
        options={{
          dateFormat: "d.m.Y",
          locale: German,
          maxDate: "today", // disable future
        }}
        onChange={handleChange}
        className="flatpickr-input"
        style={{
          fontFamily: "Tahoma, sans-serif",
          fontSize: "15px",
          width: "98%",
          height: "20px",
          border: "none",
          outline: "none",
          padding: 0,
          background: "transparent",
        }}
      />
    </Box>
  );
};
